export default {
  'menu.JuvenilesBlockReportNewPage': '未成年人阻拦上报',
}